import React, { useState, useEffect } from 'react'
import HeroBanner from '../../component/HeroBanner'
import MembersMembershipModal from '../../component/MembersMembershipModal'
import { useGlobalContext } from '../../component/GlobalContext'
import { MemberShipCardStructure } from '../../component/ReusableComponents'

const MemberShip = () => {
    const isProduction = process.env.REACT_APP_ENVIRONMENTL === 'production';
    console.log('REACT_APP_ENVIRONMENTL : ' + isProduction);
    const LIVE_MONTHLY_PRICE_ID = 'price_1RELzaA7kr33YB4lKKDLt5OC';
    const TEST_MONTHLY_PRICE_ID = 'price_1R4aPDBtU2OGzD7rSQfaIkgt';

    const LIVE_YEARLY_PRICE_ID = 'price_1REUnpA7kr33YB4lQoEX3Yfa';
    const TEST_YEARLY_PRICE_ID = 'price_1R4bUfBtU2OGzD7rhivGTYWm';

    const { globalUserVar, isAuthenticated, setIsAuthenticated, isActiveMember, userInfo } = useGlobalContext();
    const [activeTab, setActiveTab] = useState('monthly-plan')
    const [memberLogin, setMemberLogin] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        email: "",
        first_name: "",
        last_name: "",
        plan_type: "",//anual,monthly
        plan_amount: "",
        plan_for: "",//member,partner
        password: "",
        confirm_password: "",
    });
    useEffect(() => {
        window.scrollTo(0, 0)
        if (isAuthenticated) {
            let userObj = localStorage.getItem('userObj');
            if (userObj != null && userObj !== "") {
                let userJson = JSON.parse(userObj);
                setFormData((prevData) => ({
                    ...prevData,
                    email: userJson.email,
                    first_name: userJson.first_name,
                    last_name: userJson.last_name,
                }));
            }
        } else {
            let registered_first_name = localStorage.getItem('registered_first_name');
            let registered_last_name = localStorage.getItem('registered_last_name');
            let registered_email = localStorage.getItem('registered_email');
            if (registered_email != null && registered_email !== "") {
                setFormData((prevData) => ({
                    ...prevData,
                    registered_first_name: registered_first_name,
                    registered_last_name: registered_last_name,
                    email: registered_email
                }));
            }
        }
        if (isAuthenticated && userInfo) {
            setMemberLogin(`${userInfo.first_name || 'member'} ${userInfo.last_name || ''}`);
        }
        else {
            setMemberLogin(undefined);
        }

    }, [isAuthenticated, showModal, userInfo]);

    const handleTabChange = tab => {
        setActiveTab(tab)
    }
    const handlePlanClick = (plan_type, plan_amount, plan_for, price_id) => {
        // alert('here');
        setFormData((prevData) => ({
            ...prevData,
            email: "",
            plan_type: plan_type,//anual,monthly
            plan_amount: plan_amount,
            plan_for: plan_for,//member,partner
            price_id: price_id
        }));
        setShowModal(true)
    }
    return (
        <div className='w-full'>
            <MembersMembershipModal showModal={showModal} setShowModal={setShowModal} formData={formData} setFormData={setFormData} />

            <HeroBanner
                bannerTitle='Join the Family Fun Club!'
                bannerImage="/assets/grid-img/Join_the_Family_Fun_Club.jpeg"
                bannerDescription={(
                    <div className='pt-2'>
                        Become a <span className='font-bold'>Member</span> and receive
                        <span className='theme-color font-bold'> EXCLUSIVE DEALS</span> from our Local
                        Business Partners and Discounts during our Family Festivals!
                    </div>
                )}
            />

            <div className="container mx-auto py-9 px-4 sm:px-6 md:px-10">
                <div className="membership-benefits-descriptions mb-8">
                    <h2 className='section-title text-center mb-4'>Family Fun Club Member Benefits</h2>

                    <ul className='text-left sm:text-center sm:mx-4 md:mx-6 space-y-2'>
                        <li>
                            Access to <b>Deals/Discounts</b> with our Business Partners
                        </li>
                        <li>
                            Access to <b>Exclusive Online Monthly Prize Giveaways</b> (Free passes to Local Attractions, Restaurant Gift Cards, etc)
                        </li>
                        <li>
                            Access to <b>Exclusive Family Fun Club</b> "Members Only" Events
                        </li>
                        <li>
                            <b>20 FREE Raffle Tickets</b> for every Family Fun AZ Festival
                        </li>
                        <li>
                            <b>Half Off all Attractions</b> during every Family Fun AZ Festival (Santa Photos, Easter Bunny Photos, etc)
                        </li>
                    </ul>
                </div>

                <div className="mb-8">
                    <MemberShipCardStructure
                        CardWrapper="family-fun-member-card-member shadow-md"
                        heightContainer="min-h-[300px]"
                        isMemberLogin={memberLogin}
                    />
                </div>

                <div className="text-center mb-6">
                    <h4 className="section-title my-6">Membership Options</h4>
                </div>

                <div className="tabs-wrapper flex justify-center items-center mb-4">
                    <div className="tabs-container">
                        <div className="flex sm:flex-row rounded shadow-md">
                            <button
                                className={`membership-tab ${activeTab === 'monthly-plan' ? 'membership-active-tab' : ''}`}
                                onClick={() => handleTabChange('monthly-plan')}
                            >
                                Monthly
                            </button>
                            <button
                                className={`membership-tab ${activeTab === 'anual-plan' ? 'membership-active-tab' : ''}`}
                                onClick={() => handleTabChange('anual-plan')}
                            >
                                Annually
                            </button>
                        </div>
                    </div>
                </div>

                <div className="membership-detail-wrapper my-8">
                    <div className="membership-cards flex flex-col md:flex-row items-center justify-center md:space-x-8 space-y-8 md:space-y-0">
                        {activeTab === "monthly-plan" && (
                            <div className="w-full sm:w-[80%] md:w-[45%] lg:w-[30%] h-auto min-h-[400px] border border-gray-200 rounded-lg shadow-lg p-6 bg-[#6c1cff] text-white flex flex-col justify-between">
                                <div className="membership-card-title">
                                    <div className="membership-card-header flex items-center justify-between mb-1">
                                        <span className="inline-block bg-[#5906DB] p-2 rounded-full">
                                            {/* SVG */}
                                        </span>
                                        <div className="card-highlight-text font-bold">Best Deal</div>
                                    </div>
                                    <p className="text-[#DAD7E0] font-normal">
                                        Pay your Membership Fee Monthly (No Contract Required - cancel anytime)
                                    </p>
                                </div>

                                <div className="membership-card-body mb-6">
                                    <p className="text-4xl font-bold text-white">
                                        $5.99 <span className="text-xl text-gray-300">/ Month</span>
                                    </p>
                                </div>

                                <div className="membership-card-footer">
                                    <button
                                        className="w-full text-center text-[#6C1CFF] bg-white py-3 rounded-lg font-semibold transition"
                                        onClick={() =>
                                            handlePlanClick('month', 5.99, 'member', isProduction ? LIVE_MONTHLY_PRICE_ID : TEST_MONTHLY_PRICE_ID)
                                        }
                                    >
                                        Join the Club!
                                    </button>
                                </div>
                            </div>
                        )}

                        {activeTab === "anual-plan" && (
                            <div className="w-full sm:w-[80%] md:w-[45%] lg:w-[30%] h-auto min-h-[400px] border border-gray-200 rounded-lg shadow-lg p-6 bg-white flex flex-col justify-between">
                                <div className="membership-card-header">
                                    <div className="mb-1">
                                        <span className="inline-block bg-gray-100 p-2 rounded-full">
                                            {/* SVG */}
                                        </span>
                                    </div>
                                    <p className="text-[#6B6A6E] font-normal">
                                        Pay your Membership Fee Annually (No Contract Required - cancel anytime)
                                    </p>
                                </div>

                                <div className="membership-card-body mb-6">
                                    <p className="text-4xl font-bold text-gray-800">
                                        $49.99 <span className="text-xl text-gray-400">($4.16/month)</span>
                                    </p>
                                </div>

                                <div className="membership-card-footer">
                                    <button
                                        className="w-full text-center text-white py-3 rounded-lg theme-button font-semibold transition"
                                        onClick={() =>
                                            handlePlanClick('annual', 49.99, 'member', isProduction ? LIVE_YEARLY_PRICE_ID : TEST_YEARLY_PRICE_ID)
                                        }
                                    >
                                        Join the Club!
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>

    )
}

export default MemberShip